import React from "react";
import { Formik } from "formik";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@material-ui/core";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { get } from "lodash";
import * as yup from "yup";
import useNotifications from "../hooks/useNotifications";
import { SubmitButton, TextField, SelectField } from "./formik";
import { createQrScanLog, getPhysicalRoomUsers } from "../ducks/actions";

const CreateQrScanLogDialog = ({ selectedUser, setUserId, selectedRoom, handleCloseDialog }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { ok, ko } = useNotifications();

  const validationSchema = yup.object().shape({
    action: yup.string().required(),
    notes: yup.string()
  });

  const createQrScanLogRequest = async params => {
    const response = await dispatch(createQrScanLog(params));

    if (response.error) {
      let errorMessage = "";
      if (response.error.response.status === 404) {
        errorMessage = get(
          response.error,
          "response.data.errors[0].detail",
          intl.formatMessage({
            defaultMessage: "Operation failed",
            id: "Hooks.ActionRequest.OperationFailed"
          })
        );
      } else if (response.error.response.status === 422) {
        errorMessage = get(
          response.error,
          "response.data.qr_scan_log.additional_data.error_message",
          intl.formatMessage({
            defaultMessage: "Operation failed",
            id: "Hooks.ActionRequest.OperationFailed"
          })
        );
      }
      ko(errorMessage);
    } else {
      ok(
        intl.formatMessage({
          defaultMessage: "Operation succedeed",
          id: "Hooks.ActionRequest.OperationSuccedeed"
        })
      );
    }

    return response;
  };

  const onSubmit = async ({ action, notes }) => {
    await createQrScanLogRequest({ userId: selectedUser.id, roomId: selectedRoom, action, notes });
    setUserId(null);
    dispatch(getPhysicalRoomUsers({ roomId: selectedRoom }));
  };

  return (
    <Formik
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      initialValues={{ action: "", notes: "" }}
    >
      <Dialog
        open={!!selectedUser}
        onClose={handleCloseDialog}
        fullWidth
        maxWidth="lg"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {intl.formatMessage(
            {
              id: "PhysicalRoom.CreateQrScanLogDialog.AccessTitle",
              defaultMessage: "Set enter or exit for {fullName}"
            },
            { fullName: `${selectedUser.profile.first_name} ${selectedUser.profile.last_name}` }
          )}
        </DialogTitle>
        <DialogContent>
          <SelectField
            name="action"
            variant="outlined"
            label={intl.formatMessage({
              id: "PhysicalRoom.CreateQrScanLogDialog.Action",
              defaultMessage: "Action"
            })}
            options={[
              {
                value: "enter",
                label: intl.formatMessage({
                  id: "PhysicalRoom.CreateQrScanLogDialog.Enter",
                  defaultMessage: "Enter"
                })
              },
              {
                value: "exit",
                label: intl.formatMessage({
                  id: "PhysicalRoom.CreateQrScanLogDialog.Exit",
                  defaultMessage: "Exit"
                })
              }
            ]}
            elevation={8}
            fullWidth
          />
          <TextField
            name="notes"
            variant="outlined"
            label={intl.formatMessage({
              id: "PhysicalRoom.CreateQrScanLogDialog.Notes",
              defaultMessage: "Notes"
            })}
            multiline
            minRows={2}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <SubmitButton variant="contained" color="primary" size="large">
            {intl.formatMessage({
              id: "PhysicalRoom.CreateQrScanLogDialog.Save",
              defaultMessage: "Save"
            })}
          </SubmitButton>
          <Button onClick={handleCloseDialog} variant="contained" color="secondary">
            {intl.formatMessage({
              id: "PhysicalRoom.CreateQrScanLogDialog.Cancel",
              defaultMessage: "Cancel"
            })}
          </Button>
        </DialogActions>
      </Dialog>
    </Formik>
  );
};

export default CreateQrScanLogDialog;
